module.exports = new __parcel__URL__("generic-error.5e907fb3.svg").toString();